export default __webpack_public_path__ + "static/media/wmv.c87164ee.svg";